import React, { useState } from 'react';
import ScaleLoader from 'react-spinners/ScaleLoader';

const Loader = ({ isLoading }) => {
	return (
		<div className="text-center" style={{ paddingTop: '30px' }}>
			<ScaleLoader
				sizeUnit={'px'}
				size={150}
				color={'#008CBA'}
				loading={isLoading}
			/>
		</div>
	);
};

export default Loader;
